import React from 'react';
import { NavLink } from 'react-router-dom';
import './../../styles/profesional/sidebar_left.css';

const Sidebar_left = () => {
    return (
        <div className="container-sidebar">
            <NavLink to="/profesional/cuenta">Cuenta</NavLink>
            <NavLink to="/profesional/direccion">Direccion</NavLink>
            <NavLink to="/profesional/perfil">Perfil</NavLink>
            <NavLink to="/profesional/portafolio">Portafolio</NavLink>
            <NavLink to="/profesional/metodo-de-pago">Método de pago</NavLink>
            <NavLink to="/profesional/membresia">Membresia</NavLink>
        </div>
    );
};

export default Sidebar_left;
